// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"8509":"35bb27babbf6d0ad","8885":"6da94b23a772f0a4"}[chunkId] + ".css";
};